<template>
  <Row :gutter="16">
    <Col v-for="(item, index) in dataSource" :span="item.col" :key="index" class-name="marginBottom6">
      <basic-item v-if="item.slot" :label="item.label">
        <slot :name="item.slot" v-bind:info="info"></slot>
      </basic-item>
      <basic-item v-else :label="item.label" :value="info[item.value]"></basic-item>
    </Col>
  </Row>
</template>
<script>
import BasicItem from "./basicItem.vue";

export default {
  components: {
    BasicItem
  },
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    info: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style lang="less">
.marginBottom6{
  margin-bottom: 6px;
}
</style>
